module.exports = __webpack_public_path__ + "static/fipcpinkcloud4-177469942c9467a45bfb10aa6ba1d667.jpeg";